import { auth } from './auth'
import { betHistory } from './betHistory'
import { bonuses } from './bonuses'
import { common } from './common'
import { errorStatusMessage } from './errorStatusMessage'
import { home } from './home'
import { mainPageDescription } from './mainPageDescription'
import { payment } from './payment'
import { profile } from './profile'
import { promocode } from './promocode'
import { promotionsPage } from './promotionsPage'
import { pwa } from './pwa'
import { slots } from './slots'
import { terms } from './terms'
import { wheelGame } from './wheelGame'

export const locale = {
  auth,
  common,
  profile,
  payment,
  betHistory,
  slots,
  promocode,
  errorStatusMessage,
  bonuses,
  home,
  promotionsPage,
  mainPageDescription,
  wheelGame,
  pwa,
  terms,
}

export type LocaleAuthType = typeof auth
export type LocaleBetHistoryType = typeof betHistory
export type LocaleBonusesType = typeof bonuses
export type LocaleCommonType = typeof common
export type LocaleErrorStatusMessageType = typeof errorStatusMessage
export type LocaleHomeType = typeof home
export type LocaleMainPageDescriptionType = typeof mainPageDescription
export type LocalePaymentType = typeof payment
export type LocaleProfileType = typeof profile
export type LocalePromocodeType = typeof promocode
export type LocalePromotionsPageType = typeof promotionsPage
export type LocalePwaType = typeof pwa
export type LocaleSlotsType = typeof slots
export type LocaleWheelGameType = typeof wheelGame
export type LocaleTermsType = typeof terms

export type LocaleAuthKeysType = keyof LocaleAuthType
export type LocaleBetHistoryKeysType = keyof LocaleBetHistoryType
export type LocaleBonusesKeysType = keyof LocaleBonusesType
export type LocaleCommonKeysType = keyof LocaleCommonType
export type LocaleErrorStatusMessageKeysType = keyof LocaleErrorStatusMessageType
export type LocaleHomeKeysType = keyof LocaleHomeType
export type LocaleMainPageDescriptionKeysType = keyof LocaleMainPageDescriptionType
export type LocalePaymentKeysType = keyof LocalePaymentType
export type LocaleProfileKeysType = keyof LocaleProfileType
export type LocalePromocodeKeysType = keyof LocalePromocodeType
export type LocalePromotionsPageKeysType = keyof LocalePromotionsPageType
export type LocalePwaKeysType = keyof LocalePwaType
export type LocaleWheelGameKeysType = keyof LocaleWheelGameType
export type LocaleSlotsKeysType = keyof LocaleSlotsType
export type LocaleTermsKeysType = keyof LocaleTermsType

export type Locale = typeof locale

export type Paths<T> = T extends object
  ? {
      [K in keyof T & string]: T[K] extends object ? `${K}` | `${K}.${Paths<T[K]>}` : `${K}`
    }[keyof T & string]
  : never

export type LocaleKeysType = Paths<Locale>
